import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Clock, Info } from 'lucide-react';
import { format } from 'date-fns';
import { usePaymentProcessingEnabled } from '@/hooks/usePaymentProcessingEnabled';

interface AchPendingBannerProps {
  settlementDate: string;
  showDetailedMessage?: boolean;
}

export function AchPendingBanner({ settlementDate, showDetailedMessage = false }: AchPendingBannerProps) {
  const { paymentProcessingEnabled, isLoading: flagLoading } = usePaymentProcessingEnabled();

  if (flagLoading || !paymentProcessingEnabled) return null;

  let formattedDate = '3-5 business days';
  
  if (settlementDate) {
    try {
      formattedDate = format(new Date(settlementDate), 'MMM d, yyyy');
    } catch (error) {
      console.error('Invalid settlement date in banner:', settlementDate, error);
    }
  }
  
  return (
    <Alert className="border-blue-200 bg-blue-50 dark:bg-blue-950 dark:border-blue-800">
      <div className="flex items-start gap-3">
        <Clock className="h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5" />
        <div className="flex-1">
          <AlertTitle className="text-blue-900 dark:text-blue-100 font-semibold mb-1">
            ACH Payment Processing
          </AlertTitle>
          <AlertDescription className="text-blue-800 dark:text-blue-200 space-y-2">
            <p>
              Your bank transfer payment is being processed and will settle by <strong>{formattedDate}</strong> 
              {' '}(typically 3-5 business days).
            </p>
            {showDetailedMessage && (
              <div className="flex items-start gap-2 mt-3 p-3 bg-blue-100 dark:bg-blue-900 rounded-md">
                <Info className="h-4 w-4 text-blue-700 dark:text-blue-300 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-blue-900 dark:text-blue-100">
                  <strong>Good news!</strong> Your Purchase Order will be automatically created and issued 
                  once the payment clears. You'll receive a notification when it's ready.
                </p>
              </div>
            )}
          </AlertDescription>
        </div>
      </div>
    </Alert>
  );
}
